import { useMemo } from 'react';
import { ISectionDefinitionData } from 'types/order/fees/ISectionDefinition';
import { ISettlementItemForm } from 'types/order/fees/ICreateSettlementItemForm';

export const useGetOptionsFromSectionDefinition = (
  lineItem: ISettlementItemForm,
  sectionDefinition: ISectionDefinitionData
) => {
  return useMemo(() => {
    if (!sectionDefinition) {
      return [];
    }
    const allDefinitions = sectionDefinition.statementSettlementAndFeeCategoryDefinitions;
    const thisDefinition = allDefinitions.filter(
      (t) => t.statementSettlementAndFeeCategoryDefinitionId === lineItem?.statementSettlementAndFeeCategoryDefinitionId
    );
    const editableDefinitions = allDefinitions.filter(
      (t) =>
        t.editable &&
        t.statementSettlementAndFeeCategoryDefinitionId !== lineItem?.statementSettlementAndFeeCategoryDefinitionId
    );
    return [...thisDefinition, ...editableDefinitions];
  }, [sectionDefinition, lineItem?.statementSettlementAndFeeCategoryDefinitionId]);
};
